const C = {
  name: "EmoticonHappy",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 17C9.79228 17 8 15.2077 8 13H6C6 16.3123 8.68772 19 12 19C15.3123 19 18 16.3123 18 13H16C16 15.2077 14.2077 17 12 17Z" fill="currentColor"/>
<path d="M8 10C7.45228 10 7 10.4523 7 11H5C5 9.34772 6.34772 8 8 8C9.65228 8 11 9.34772 11 11H9C9 10.4523 8.54772 10 8 10Z" fill="currentColor"/>
<path d="M15 11C15 10.4523 15.4523 10 16 10C16.5477 10 17 10.4523 17 11H19C19 9.34772 17.6523 8 16 8C14.3477 8 13 9.34772 13 11H15Z" fill="currentColor"/>
<path d="M12 1C5.92772 1 1 5.92772 1 12C1 18.0723 5.92772 23 12 23C18.0723 23 23 18.0723 23 12C23 5.92772 18.0723 1 12 1ZM3 12C3 7.03228 7.03228 3 12 3C16.9677 3 21 7.03228 21 12C21 16.9677 16.9677 21 12 21C7.03228 21 3 16.9677 3 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as EmoticonHappy
};
